import { FormField, MultiInputSearch } from '@domain-group/suit-theme'

import useTags from '@hooks/useTags'
import { TagModel } from '@models/types'

const tagsToResultObjectInterface = (tags: TagModel[]) => {
  return tags.map((tag) => {
    return {
      key: tag.id,
      text: tag.title,
    }
  })
}

interface TagInputProps {
  selectedTagIds: number[]
  setSelectedTagIds: (tagIds: number[]) => void
}

const TagInput = (props: TagInputProps) => {
  const {
    selectedTagIds,
    setSelectedTagIds
  } = props

  const tagsPayload = useTags({
    performHttpRequests: true,
  })

  const tagIdsToSelections = () => {
    return tagsToResultObjectInterface(tagsPayload.filteredTags)
      .filter((tag) => {
        return selectedTagIds.includes(tag.key)
      })
  }

  return (
    <FormField direction="column" label="Manage Tags" marginTop="large">
      <MultiInputSearch
        disabled={tagsPayload.loading}
        results={
          {
            groups: [{ items: tagsToResultObjectInterface(tagsPayload.filteredTags), key: 'tags'}]
          }
        }
        selectItem={(item) => setSelectedTagIds([...selectedTagIds, Number(item.key)])}
        deleteItem={(item) => {
          setSelectedTagIds(
            selectedTagIds.filter(selection => selection !== item.key)
          )
        }}
        selections={tagIdsToSelections()}
        placeholder="Search for tags"
      />
    </FormField>
  )
}

export default TagInput